import React from 'react';
import { Form } from 'react-bootstrap';

class ValueTypeSelectBox extends React.Component {
  
  renderValueTypeSelectBox(props) {
    let result;
    result = (
      <Form.Group controlId={`form-value-type-${Date.now()}`}>
        <Form.Label>Value Type</Form.Label>
        <Form.Control
          size="sm"
          as="select"
          {...props}
        >
          <option value={'Percentage'}>Percentage</option>
          <option value={'Currency'}>Currency</option>
        </Form.Control>
      </Form.Group>
    );
    return result;
  }

  render() {
    return this.renderValueTypeSelectBox(this.props);
  }
}


export default ValueTypeSelectBox;

